import * as types from './mutations_types.js'

export const state = {
  products: [],
  popular: [],
  addon: [],
  shareid: 0
}

export const mutations = {
  [types.SET_PRODUCTS] (state, data) {
    state.products = data
    window.localStorage.setItem('products', JSON.stringify(data))
  },
  [types.SET_POPULAR] (state, data) {
    state.popular = data
    // console.log(data)
    window.localStorage.setItem('popular', JSON.stringify(data))
  },
  [types.SET_ADDON] (state, data) {
    state.addon = data
    window.localStorage.setItem('addon', JSON.stringify(data))
  },
  [types.SET_SHARE_ID] (state, shareid) {
    state.shareid = shareid
    window.localStorage.setItem('shareid', shareid)
  }
}



// WEBPACK FOOTER //
// ./src/store/product/mutations.js